import React from 'react'
import { PALETTE } from '../../styles/constants'

function CloseIcon({ width = 24, height = 24, color = PALETTE.gray80, opacity = '1' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <g opacity={opacity} clipPath="url(#clip0_2352_919)">
        <path d="M18.167 7.05L17.117 6L12.167 10.95L7.21699 6L6.16699 7.05L11.117 12L6.16699 16.95L7.21699 18L12.167 13.05L17.117 18L18.167 16.95L13.217 12L18.167 7.05Z" fill={color}/>
      </g>
      <defs>
        <clipPath id="clip0_2352_919">
          <rect width={width} height={height} fill="white" transform="translate(0.166992)"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default CloseIcon
